import styled from 'styled-components';
import { DEFAULT_FONT_FAMILY } from 'common/constants';

export const Root = styled.div`
  width: 100%;
  position: relative;
  display: grid;
  margin-bottom: 21px;
`;

export const Title = styled.label`
  font-family: ${DEFAULT_FONT_FAMILY};
  font-size: 20px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #000;
`;
export const Col = styled.div`
  display: block;
  width: min-content;
`;

export const Row = styled.div`
  width: 100%;
  display: flex;
  position: relative;
  justify-content: space-between;
`;

export const Selectcontainer = styled.div`
  width: 250px;
  margin-right: 10px;
  margin-top: 15px;
`;


export const SortByTitle = styled.label`
  font-family: ${DEFAULT_FONT_FAMILY};
  font-size: 20px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #000;
`;

export const ChipsContainer = styled.div`
  width: 100%;
  display: flex;
  margin-top: 17px;
  gap: 7px;
`;

export const EditRatingsContainer = styled.div`
  position: relative;
`;

export const EditIconContainer = styled.div`
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 30px;
  height: 30px;
  border-radius: 20px;
  &:hover {
    background-color: rgba(18, 36, 66, 0.05);
  }
  margin-right: 10px;
  margin-top: 15px;
`;

export const KeywordsInput = styled.input`
  border-radius: 5px;
  border: solid 1px #e7e7ec;
  background-color: #fff;
  font-family: Rubik;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #2d3548;
  padding: 5px 0 5px 10px;
  &:focus {
    outline: none !important;
  }
`;